export const ALERT_MESSAGES_COOKIE_NAME = 'alert_messages_dismissed';
export const ALERT_MESSAGES_COOKIE_EXPIRES = 365;
export const ALERT_MESSAGES_CYCLE_INTERVAL_MS = 5 * 1000;
